var map = {
	"./erf-icon-book.png": 571,
	"./erf-icon-course.png": 572,
	"./erf-icon-edu.png": 573,
	"./erf-icon-home.png": 574,
	"./erf-icon-hxd.png": 575,
	"./erf-icon-setting.png": 576
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 743;


//////////////////
// WEBPACK FOOTER
// ./static ^\.\/.*\.png$
// module id = 743
// module chunks = 1